import { useMemo, useState } from "react";

export const useShowAll = <T>(data: T[]) => {
  const [showAll, setShowAll] = useState(false);

  const displayedData = useMemo(() => (showAll ? data : data.slice(0, 3)), [showAll, data]);

  return { showAll, setShowAll, displayedData };
};
